/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./testimonials.css";
import AVTR1 from "../../assets/avatar1.jpg";
import AVTR2 from "../../assets/avatar2.jpg";
import AVTR3 from "../../assets/avatar3.jpg";
import AVTR4 from "../../assets/avatar4.jpg";

// import Swiper core and required modules
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const data = [
  {
    avatar: AVTR4,
    name: "Tina Snow",
    review:
      "Arefin is an excellent professional, always very attentive, always seeks to improve his knowledge and works in a humanized way, and is always willing to deliver the best work.",
  },
  {
    avatar: AVTR2,
    name: "Shatta Wale",
    review:
      "He is job fantastic! Appreciate his efforts.",
  },
  {
    avatar: AVTR3,
    name: "Kwame Despite",
    review:
      "Arefin delivered fantastic work even before the due date. I will definitely order again. Thank you.",
  },
  {
    avatar: AVTR1,
    name: "Nana Ama McBrown",
    review:
      "Outstanding work as usual. Will contact again.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper
        className="container testimonials__container"
        // install Swiper modules
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {data.map(({ avatar, name, review }, index) => {
          return (
            <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img src={avatar} />
              </div>
              <h5 className="client__name">{name}</h5>
              <small className="client__review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
